import { Button } from '@shared/components/Button';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { useIsMobile } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import classNames from './RemoteChangesWarningBanner.module.css';

interface FormWarningProps {
  header: string;
  subheader: string;
  onDismiss: () => void;
  onRevert?: () => void;
}

export function RemoteChangesWarningBanner({
  header,
  subheader,
  onDismiss,
  onRevert,
}: FormWarningProps) {
  const isMobile = useIsMobile();
  const align = isMobile ? 'center' : 'left';

  return (
    <View className={classNames.banner}>
      <View className={classNames.header}>
        <Text align={align} weight="bold">
          {header}
        </Text>
        <Text align={align} weight="normal">
          {subheader}
        </Text>
      </View>
      <View row className={classNames.actions}>
        <Button
          variant="ghost"
          label={i18n('card.update.remoteConflictKeepEditing')}
          size="medium"
          onClick={onDismiss}
        />
        {onRevert && (
          <Button
            variant="secondary"
            size="medium"
            label={i18n('card.update.remoteConflictRevert')}
            onClick={onRevert}
          />
        )}
      </View>
    </View>
  );
}
